import { ThemeList } from 'store/ducks/globalTypes';

const ColorPalettes = (t: (key: string) => string) => [
  {
    label: t('THEMES.DEEP_BLUE'),
    value: ThemeList.MAIN_THEME,
  },
  {
    label: t('THEMES.DEEP_NAVY'),
    value: ThemeList.CORAL_MIST,
  },
  {
    label: t('THEMES.DARK_UI'),
    value: ThemeList.FIRST_THEME,
  },
  {
    label: t('THEMES.LIGHT_UI'),
    value: ThemeList.SECOND_THEME,
  },
  {
    label: t('THEMES.PINK_UI'),
    value: ThemeList.FIFTH_THEME,
  },
  {
    label: t('THEMES.GREEN_MODE'),
    value: ThemeList.SEVENTH_THEME,
  },
  {
    label: t('THEMES.AQUA_SERENITY'),
    value: ThemeList.EIGHTH_THEME,
  },
  {
    label: t('THEMES.DESERT_GOLD'),
    value: ThemeList.NINTH_THEME,
  },
  {
    label: t('THEMES.LILAC'),
    value: ThemeList.LILAC_THEME,
  },
  {
    label: t('THEMES.SLATE_STEEL'),
    value: ThemeList.SLATE_STEEL,
  },
  {
    label: t('THEMES.TURQUOISE'),
    value: ThemeList.TURQUOISE,
  },
  {
    label: t('THEMES.ARCTIC_HORIZON'),
    value: ThemeList.LIGHT_UI_THEME,
  },
];

export default ColorPalettes;
